// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--59d4f","image":"styles-module--image--cc5f7"};